import * as Yup from 'yup';

const organizationSchema = Yup.object().shape({
  name: Yup.string().required('Name is Required'),
  locations: Yup.array().of(
    Yup.object().shape({
      address: Yup.object().shape({
        address1: Yup.string().nullable(),
        address2: Yup.string().nullable(),
        address3: Yup.string().nullable(),
        city: Yup.string(),
        state: Yup.number(),
        postalCode: Yup.string()
      })
    })
  ),
  roles: Yup.array()
});

export default organizationSchema;
